import { render, staticRenderFns } from "./recallNoticeTemplate.vue?vue&type=template&id=4d5944fd"
import script from "./recallNoticeTemplate.vue?vue&type=script&lang=js"
export * from "./recallNoticeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports